import { useContext, useEffect, useState } from 'react'
import { UserContext } from '../state/user-state'
import { useQuery } from 'react-query'
import fetchApi from '../services/api'

export type WellPermissions = {
  canEdit: boolean
  canView: boolean
  canCreate: boolean
}

export default function useWellPermissions(wellId: number | string): WellPermissions | null {
  const { state } = useContext(UserContext)
  const [result, setResult] = useState<WellPermissions | null>(null)
  const url = `wells/${wellId}/perms`
  const { isLoading, isError, isSuccess, data } = useQuery([wellId, state.token], () =>
    fetchApi({ url, token: state.token, auth_method: state.auth_method }),
  )
  useEffect(() => {
    if (!isLoading && !isError && isSuccess && data) {
      // Completed, and we have data
      setResult(data)
    }
  }, [isLoading, isError, isSuccess, data, result])

  return result
}
